// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.h7mpwEJdV4MbabsO {
	margin-top: 3rem;
	display: flex;
	flex-direction: column;
}

.h7mpwEJdV4MbabsO > h3 {
	margin-block-end: 0;
}

.VzoN2HOB1MK6QYt_ {
	display: flex;
	flex-direction: row;
	margin-top: 1rem;
	gap: 1.625rem;
}

.gCypkPVVZYnFa_hh {
	width: 30rem;
	height: 28rem;
	box-shadow: 2px 7px 18px 3px rgba(0, 0, 0, 0.06);
	border-radius: 16px;
}

.a3BewcesEvIca0PY {
	width: 30rem;
	height: 28rem;
	box-shadow: 2px 7px 18px 3px rgba(0, 0, 0, 0.06);
	border-radius: 16px;
}

.ahyuFXrae04ItvA7 {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}

.Sb2oxBfh71cCntoA {
	width: 250px;
	height: 250px;
	margin-top: 28px;
}

.oWO1O9Y_pDc9Wz2P {
	margin-top: 38px;
	display: flex;
	gap: 70px;
}

.GbUK_ulCL4_iYyvS {
	display: flex;
	flex-direction: row;
}

.Kd1Cu29uAAN9VNu1 {
	margin-left: 0.5rem;
	margin-top: -0.35rem;
	font-weight: 400;
	font-size: 14px;
}

.WUMelefkZNQJJ6Fe {
	margin-left: 0.5rem;
	margin-top: 0.15rem;
	font-weight: 700;
	font-size: 20px;
}

.KjsVkF88_k5Gkx4_ {
	margin-top: -0.15rem;
	width: 0.5rem;
	height: 0.5rem;
	border-radius: 50%;
}

.Ll3rZz7id5wZoNB_ {
	color: #20336C;
	font-weight: 900;
	font-size: 3.375rem;
	display: flex;
	flex-direction: row;
	align-content: center;
	justify-content: center;
	margin-top: 30%;
}

.W79xGQzqTuc6ECc0 {
	margin-top: 3rem;
	display: flex;
	flex-direction: column;
}

.p-datatable-table {
	border-radius: 16px;
	overflow: hidden;
}

.p-datatable-thead th:first-child > div {
	display: flex;
	justify-content: flex-start;
}

.p-datatable-thead th > div {
	display: flex;
	justify-content: center;
	color: #303030;
	font-size: 1.25rem;
	font-weight: 600;
}

.p-datatable-thead th {
	background-color: #C6D4E1;
	border: 1px solid #F3F5F7;
	padding: 18px 30px;
}

.p-datatable-tbody tr td {
	text-align: center;
	border: 1px solid #F3F5F7;
	font-size: 1.25rem;
	font-weight: 400;
}

.p-datatable-tbody tr td:first-child > div {
	display: flex;
	justify-content: flex-start;
	margin-left: 0.8rem;
}

.wf_ILWo04gS4M8u8 {
	color: #3254B9;
}

.Ijgt54fh69YSQyTe table tr {
	width: 100%;
	display: grid;
	grid-template-columns: 3fr 1fr 1fr 1fr;
	grid-template-areas: "name name name orders cost avg";
}

.Ut0J3vuXbFkaUtZi {
	grid-area: name;
}

.BBzn2su5Wu0eX7ws {
	grid-area: orders;
}

.rAS5iAeu7wTid_Iu {
	grid-area: cost;
}

.eeXFbYAcxiwJ0B_g {
	grid-area: avg;
}

/*@media screen and (max-width: 1440px) {*/
/*	.cardWrapper {*/
/*		gap: 0.7rem;*/
/*	}*/
/*	*/
/*	.chartCard {*/
/*		width: 22.4rem;*/
/*	}*/
/*	*/
/*	.customLegend {*/
/*		gap: 3rem;*/
/*	}*/
/*	*/
/*	.card {*/
/*		width: 22rem;*/
/*	}*/
/*	*/
/*	.table table tr {*/
/*		grid-template-columns: 2fr 1fr 1fr 1fr;*/
/*		grid-template-areas: "name name orders cost avg";*/
/*	}*/
/*	*/
/*	.table :global(.p-datatable-thead th:first-child > div) {*/
/*		margin-left: 30px;*/
/*	}*/
/*}*/

@media screen and (min-width: 1024px) and (max-width: 1665px) {
	.VzoN2HOB1MK6QYt_ {
		gap: 0.5rem;
		flex-wrap: nowrap;
		justify-content: space-between;
		width: 100%;
	}
	
	.gCypkPVVZYnFa_hh {
		flex: 1 1 calc(33.33% - 0.5rem);
		width: calc(33.33% - 0.5rem);
		max-width: none;
		min-width: 0;
		height: 24rem;
	}
	
	.a3BewcesEvIca0PY {
		flex: 1 1 calc(33.33% - 0.5rem);
		width: calc(33.33% - 0.5rem);
		max-width: none;
		min-width: 0;
		height: 24rem;
	}
	
	.Ll3rZz7id5wZoNB_ {
		font-size: 2.5rem;
	}
	
	.Ijgt54fh69YSQyTe table tr {
		width: 100%;
		display: table-row;
		grid-template-columns: unset;
		grid-template-areas: unset;
	}
	
	.Ijgt54fh69YSQyTe table {
		width: 100%;
		table-layout: fixed;
		border-collapse: separate;
	}
	
	.Ijgt54fh69YSQyTe table th,
	.Ijgt54fh69YSQyTe table td {
		display: table-cell;
		vertical-align: middle;
	}
	
	.Ijgt54fh69YSQyTe table th:nth-child(1),
	.Ijgt54fh69YSQyTe table td:nth-child(1) {
		width: 40%;
	}
	
	.Ijgt54fh69YSQyTe table th:nth-child(2),
	.Ijgt54fh69YSQyTe table td:nth-child(2) {
		width: 20%;
	}
	
	.Ijgt54fh69YSQyTe table th:nth-child(3),
	.Ijgt54fh69YSQyTe table td:nth-child(3) {
		width: 20%;
	}
	
	.Ijgt54fh69YSQyTe table th:nth-child(4),
	.Ijgt54fh69YSQyTe table td:nth-child(4) {
		width: 20%;
	}
	
	.Ut0J3vuXbFkaUtZi,
	.BBzn2su5Wu0eX7ws,
	.rAS5iAeu7wTid_Iu,
	.eeXFbYAcxiwJ0B_g {
		grid-area: unset;
		display: block;
		width: 100%;
	}
	
	.Ijgt54fh69YSQyTe .p-datatable-thead th:first-child > div {
		margin-left: 30px;
	}
}

@media screen and (min-width: 1195px) and (max-width: 1665px){
	.Sb2oxBfh71cCntoA {
		margin-top: -0.2rem;
		width: 240px;
		height: 240px;
	}
	
	.oWO1O9Y_pDc9Wz2P {
		gap: 2rem;
		margin-top: 1.8rem;
	}
}

@media screen and (min-width: 1105px) and (max-width: 1194px){
	.Sb2oxBfh71cCntoA {
		width: 200px;
		height: 200px;
	}
	
	.oWO1O9Y_pDc9Wz2P {
		gap: 2rem;
		margin-top: 2rem;
	}
}

@media screen and (min-width: 1105px) and (max-width: 1193px) {
	.oWO1O9Y_pDc9Wz2P {
		gap: 1rem;
	}
}

@media screen and (max-width: 1104px) {
	.VzoN2HOB1MK6QYt_ {
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
	
	.gCypkPVVZYnFa_hh {
		width: 24rem;
		height: 27rem;
	}
	
	.gCypkPVVZYnFa_hh .p-card-title {
		color: #303030;
		font-size: 16px;
		font-weight: 700;
	}
	
	.a3BewcesEvIca0PY {
		width: 24rem;
		height: 88px;
	}
	
	.a3BewcesEvIca0PY .p-card-title {
		color: #767676;
		font-size: 12px;
		font-weight: 400;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	.a3BewcesEvIca0PY .p-card-content {
		margin-top: -15px;
	}
	
	.Ll3rZz7id5wZoNB_ {
		margin: 0;
		font-size: 30px;
	}
	
	.Ijgt54fh69YSQyTe table tr {
		grid-template-columns: 2fr 1fr 1fr 1fr;
		grid-template-areas: "name name orders cost avg";
	}
	
	.Ijgt54fh69YSQyTe table thead tr th {
		max-height: 31px !important;
	}
	
	.Ijgt54fh69YSQyTe .p-datatable-thead th {
		padding: 10px 0;
	}
	
	.Ijgt54fh69YSQyTe .p-datatable-thead th:first-child > div {
		margin-left: 30px;
	}
}

@media screen and (max-width: 768px) {
	.Ijgt54fh69YSQyTe table thead tr th > div > span {
		font-size: 10px;
		font-weight: 700;
	}
	
	.Ijgt54fh69YSQyTe table tbody tr td > div {
		font-size: 10px;
		font-weight: 400;
	}
}

@media screen and (max-width: 425px) {
	.Ijgt54fh69YSQyTe table tr {
		grid-template-columns: 2fr 1fr 1fr 2fr;
		grid-template-areas: "name name orders cost avg avg";
	}
}`, "",{"version":3,"sources":["webpack://./src/pages/Manager/components/Statistic/StationsStatistics.module.css"],"names":[],"mappings":"AAAA;CACC,gBAAgB;CAChB,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,gBAAgB;CAChB,aAAa;AACd;;AAEA;CACC,YAAY;CACZ,aAAa;CACb,gDAAgD;CAChD,mBAAmB;AACpB;;AAEA;CACC,YAAY;CACZ,aAAa;CACb,gDAAgD;CAChD,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;CACC,YAAY;CACZ,aAAa;CACb,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;CAChB,aAAa;CACb,SAAS;AACV;;AAEA;CACC,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;CACnB,oBAAoB;CACpB,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,mBAAmB;CACnB,mBAAmB;CACnB,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,oBAAoB;CACpB,aAAa;CACb,cAAc;CACd,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,gBAAgB;CAChB,mBAAmB;CACnB,aAAa;CACb,mBAAmB;CACnB,qBAAqB;CACrB,uBAAuB;CACvB,eAAe;AAChB;;AAEA;CACC,gBAAgB;CAChB,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,2BAA2B;AAC5B;;AAEA;CACC,aAAa;CACb,uBAAuB;CACvB,cAAc;CACd,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,yBAAyB;CACzB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,yBAAyB;CACzB,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,2BAA2B;CAC3B,mBAAmB;AACpB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,WAAW;CACX,aAAa;CACb,sCAAsC;CACtC,qDAAqD;AACtD;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,cAAc;AACf;;AAEA,0CAA0C;AAC1C,kBAAkB;AAClB,iBAAiB;AACjB,KAAK;AACL,IAAI;AACJ,gBAAgB;AAChB,oBAAoB;AACpB,KAAK;AACL,IAAI;AACJ,mBAAmB;AACnB,eAAe;AACf,KAAK;AACL,IAAI;AACJ,WAAW;AACX,kBAAkB;AAClB,KAAK;AACL,IAAI;AACJ,qBAAqB;AACrB,4CAA4C;AAC5C,sDAAsD;AACtD,KAAK;AACL,IAAI;AACJ,6DAA6D;AAC7D,uBAAuB;AACvB,KAAK;AACL,IAAI;;AAEJ;CACC;EACC,WAAW;EACX,iBAAiB;EACjB,8BAA8B;EAC9B,WAAW;CACZ;;CAEA;EACC,+BAA+B;EAC/B,4BAA4B;EAC5B,eAAe;EACf,YAAY;EACZ,aAAa;CACd;;CAEA;EACC,+BAA+B;EAC/B,4BAA4B;EAC5B,eAAe;EACf,YAAY;EACZ,aAAa;CACd;;CAEA;EACC,iBAAiB;CAClB;;CAEA;EACC,WAAW;EACX,kBAAkB;EAClB,4BAA4B;EAC5B,0BAA0B;CAC3B;;CAEA;EACC,WAAW;EACX,mBAAmB;EACnB,yBAAyB;CAC1B;;CAEA;;EAEC,mBAAmB;EACnB,sBAAsB;CACvB;;CAEA;;EAEC,UAAU;CACX;;CAEA;;EAEC,UAAU;CACX;;CAEA;;EAEC,UAAU;CACX;;CAEA;;EAEC,UAAU;CACX;;CAEA;;;;EAIC,gBAAgB;EAChB,cAAc;EACd,WAAW;CACZ;;CAEA;EACC,iBAAiB;CAClB;AACD;;AAEA;CACC;EACC,mBAAmB;EACnB,YAAY;EACZ,aAAa;CACd;;CAEA;EACC,SAAS;EACT,kBAAkB;CACnB;AACD;;AAEA;CACC;EACC,YAAY;EACZ,aAAa;CACd;;CAEA;EACC,SAAS;EACT,gBAAgB;CACjB;AACD;;AAEA;CACC;EACC,SAAS;CACV;AACD;;AAEA;CACC;EACC,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;CACxB;;CAEA;EACC,YAAY;EACZ,aAAa;CACd;;CAEA;EACC,cAAc;EACd,eAAe;EACf,gBAAgB;CACjB;;CAEA;EACC,YAAY;EACZ,YAAY;CACb;;CAEA;EACC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;CACxB;;CAEA;EACC,iBAAiB;CAClB;;CAEA;EACC,SAAS;EACT,eAAe;CAChB;;CAEA;EACC,sCAAsC;EACtC,gDAAgD;CACjD;;CAEA;EACC,2BAA2B;CAC5B;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,iBAAiB;CAClB;AACD;;AAEA;CACC;EACC,eAAe;EACf,gBAAgB;CACjB;;CAEA;EACC,eAAe;EACf,gBAAgB;CACjB;AACD;;AAEA;CACC;EACC,sCAAsC;EACtC,oDAAoD;CACrD;AACD","sourcesContent":[".chartsBlock {\r\n\tmargin-top: 3rem;\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n}\r\n\r\n.chartsBlock > h3 {\r\n\tmargin-block-end: 0;\r\n}\r\n\r\n.cardWrapper {\r\n\tdisplay: flex;\r\n\tflex-direction: row;\r\n\tmargin-top: 1rem;\r\n\tgap: 1.625rem;\r\n}\r\n\r\n.chartCard {\r\n\twidth: 30rem;\r\n\theight: 28rem;\r\n\tbox-shadow: 2px 7px 18px 3px rgba(0, 0, 0, 0.06);\r\n\tborder-radius: 16px;\r\n}\r\n\r\n.card {\r\n\twidth: 30rem;\r\n\theight: 28rem;\r\n\tbox-shadow: 2px 7px 18px 3px rgba(0, 0, 0, 0.06);\r\n\tborder-radius: 16px;\r\n}\r\n\r\n.totalOrdersCardContent {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tjustify-content: center;\r\n\talign-items: center;\r\n}\r\n\r\n.doughnut {\r\n\twidth: 250px;\r\n\theight: 250px;\r\n\tmargin-top: 28px;\r\n}\r\n\r\n.customLegend {\r\n\tmargin-top: 38px;\r\n\tdisplay: flex;\r\n\tgap: 70px;\r\n}\r\n\r\n.label {\r\n\tdisplay: flex;\r\n\tflex-direction: row;\r\n}\r\n\r\n.labelTitle {\r\n\tmargin-left: 0.5rem;\r\n\tmargin-top: -0.35rem;\r\n\tfont-weight: 400;\r\n\tfont-size: 14px;\r\n}\r\n\r\n.labelValue {\r\n\tmargin-left: 0.5rem;\r\n\tmargin-top: 0.15rem;\r\n\tfont-weight: 700;\r\n\tfont-size: 20px;\r\n}\r\n\r\n.labelDot {\r\n\tmargin-top: -0.15rem;\r\n\twidth: 0.5rem;\r\n\theight: 0.5rem;\r\n\tborder-radius: 50%;\r\n}\r\n\r\n.cost {\r\n\tcolor: #20336C;\r\n\tfont-weight: 900;\r\n\tfont-size: 3.375rem;\r\n\tdisplay: flex;\r\n\tflex-direction: row;\r\n\talign-content: center;\r\n\tjustify-content: center;\r\n\tmargin-top: 30%;\r\n}\r\n\r\n.costsBlock {\r\n\tmargin-top: 3rem;\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n}\r\n\r\n:global(.p-datatable-table) {\r\n\tborder-radius: 16px;\r\n\toverflow: hidden;\r\n}\r\n\r\n:global(.p-datatable-thead th:first-child > div) {\r\n\tdisplay: flex;\r\n\tjustify-content: flex-start;\r\n}\r\n\r\n:global(.p-datatable-thead th > div) {\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n\tcolor: #303030;\r\n\tfont-size: 1.25rem;\r\n\tfont-weight: 600;\r\n}\r\n\r\n:global(.p-datatable-thead th) {\r\n\tbackground-color: #C6D4E1;\r\n\tborder: 1px solid #F3F5F7;\r\n\tpadding: 18px 30px;\r\n}\r\n\r\n:global(.p-datatable-tbody tr td) {\r\n\ttext-align: center;\r\n\tborder: 1px solid #F3F5F7;\r\n\tfont-size: 1.25rem;\r\n\tfont-weight: 400;\r\n}\r\n\r\n:global(.p-datatable-tbody tr td:first-child > div) {\r\n\tdisplay: flex;\r\n\tjustify-content: flex-start;\r\n\tmargin-left: 0.8rem;\r\n}\r\n\r\n.downloadBtn {\r\n\tcolor: #3254B9;\r\n}\r\n\r\n.table table tr {\r\n\twidth: 100%;\r\n\tdisplay: grid;\r\n\tgrid-template-columns: 3fr 1fr 1fr 1fr;\r\n\tgrid-template-areas: \"name name name orders cost avg\";\r\n}\r\n\r\n.cellName {\r\n\tgrid-area: name;\r\n}\r\n\r\n.cellOrders {\r\n\tgrid-area: orders;\r\n}\r\n\r\n.cellCost {\r\n\tgrid-area: cost;\r\n}\r\n\r\n.cellAvg {\r\n\tgrid-area: avg;\r\n}\r\n\r\n/*@media screen and (max-width: 1440px) {*/\r\n/*\t.cardWrapper {*/\r\n/*\t\tgap: 0.7rem;*/\r\n/*\t}*/\r\n/*\t*/\r\n/*\t.chartCard {*/\r\n/*\t\twidth: 22.4rem;*/\r\n/*\t}*/\r\n/*\t*/\r\n/*\t.customLegend {*/\r\n/*\t\tgap: 3rem;*/\r\n/*\t}*/\r\n/*\t*/\r\n/*\t.card {*/\r\n/*\t\twidth: 22rem;*/\r\n/*\t}*/\r\n/*\t*/\r\n/*\t.table table tr {*/\r\n/*\t\tgrid-template-columns: 2fr 1fr 1fr 1fr;*/\r\n/*\t\tgrid-template-areas: \"name name orders cost avg\";*/\r\n/*\t}*/\r\n/*\t*/\r\n/*\t.table :global(.p-datatable-thead th:first-child > div) {*/\r\n/*\t\tmargin-left: 30px;*/\r\n/*\t}*/\r\n/*}*/\r\n\r\n@media screen and (min-width: 1024px) and (max-width: 1665px) {\r\n\t.cardWrapper {\r\n\t\tgap: 0.5rem;\r\n\t\tflex-wrap: nowrap;\r\n\t\tjustify-content: space-between;\r\n\t\twidth: 100%;\r\n\t}\r\n\t\r\n\t.chartCard {\r\n\t\tflex: 1 1 calc(33.33% - 0.5rem);\r\n\t\twidth: calc(33.33% - 0.5rem);\r\n\t\tmax-width: none;\r\n\t\tmin-width: 0;\r\n\t\theight: 24rem;\r\n\t}\r\n\t\r\n\t.card {\r\n\t\tflex: 1 1 calc(33.33% - 0.5rem);\r\n\t\twidth: calc(33.33% - 0.5rem);\r\n\t\tmax-width: none;\r\n\t\tmin-width: 0;\r\n\t\theight: 24rem;\r\n\t}\r\n\t\r\n\t.cost {\r\n\t\tfont-size: 2.5rem;\r\n\t}\r\n\t\r\n\t.table table tr {\r\n\t\twidth: 100%;\r\n\t\tdisplay: table-row;\r\n\t\tgrid-template-columns: unset;\r\n\t\tgrid-template-areas: unset;\r\n\t}\r\n\t\r\n\t.table table {\r\n\t\twidth: 100%;\r\n\t\ttable-layout: fixed;\r\n\t\tborder-collapse: separate;\r\n\t}\r\n\t\r\n\t.table table th,\r\n\t.table table td {\r\n\t\tdisplay: table-cell;\r\n\t\tvertical-align: middle;\r\n\t}\r\n\t\r\n\t.table table th:nth-child(1),\r\n\t.table table td:nth-child(1) {\r\n\t\twidth: 40%;\r\n\t}\r\n\t\r\n\t.table table th:nth-child(2),\r\n\t.table table td:nth-child(2) {\r\n\t\twidth: 20%;\r\n\t}\r\n\t\r\n\t.table table th:nth-child(3),\r\n\t.table table td:nth-child(3) {\r\n\t\twidth: 20%;\r\n\t}\r\n\t\r\n\t.table table th:nth-child(4),\r\n\t.table table td:nth-child(4) {\r\n\t\twidth: 20%;\r\n\t}\r\n\t\r\n\t.cellName,\r\n\t.cellOrders,\r\n\t.cellCost,\r\n\t.cellAvg {\r\n\t\tgrid-area: unset;\r\n\t\tdisplay: block;\r\n\t\twidth: 100%;\r\n\t}\r\n\t\r\n\t.table :global(.p-datatable-thead th:first-child > div) {\r\n\t\tmargin-left: 30px;\r\n\t}\r\n}\r\n\r\n@media screen and (min-width: 1195px) and (max-width: 1665px){\r\n\t.doughnut {\r\n\t\tmargin-top: -0.2rem;\r\n\t\twidth: 240px;\r\n\t\theight: 240px;\r\n\t}\r\n\t\r\n\t.customLegend {\r\n\t\tgap: 2rem;\r\n\t\tmargin-top: 1.8rem;\r\n\t}\r\n}\r\n\r\n@media screen and (min-width: 1105px) and (max-width: 1194px){\r\n\t.doughnut {\r\n\t\twidth: 200px;\r\n\t\theight: 200px;\r\n\t}\r\n\t\r\n\t.customLegend {\r\n\t\tgap: 2rem;\r\n\t\tmargin-top: 2rem;\r\n\t}\r\n}\r\n\r\n@media screen and (min-width: 1105px) and (max-width: 1193px) {\r\n\t.customLegend {\r\n\t\tgap: 1rem;\r\n\t}\r\n}\r\n\r\n@media screen and (max-width: 1104px) {\r\n\t.cardWrapper {\r\n\t\tflex-direction: column;\r\n\t\talign-items: center;\r\n\t\tjustify-content: center;\r\n\t}\r\n\t\r\n\t.chartCard {\r\n\t\twidth: 24rem;\r\n\t\theight: 27rem;\r\n\t}\r\n\t\r\n\t.chartCard :global(.p-card-title) {\r\n\t\tcolor: #303030;\r\n\t\tfont-size: 16px;\r\n\t\tfont-weight: 700;\r\n\t}\r\n\t\r\n\t.card {\r\n\t\twidth: 24rem;\r\n\t\theight: 88px;\r\n\t}\r\n\t\r\n\t.card :global(.p-card-title) {\r\n\t\tcolor: #767676;\r\n\t\tfont-size: 12px;\r\n\t\tfont-weight: 400;\r\n\t\tdisplay: flex;\r\n\t\talign-items: center;\r\n\t\tjustify-content: center;\r\n\t}\r\n\t\r\n\t.card :global(.p-card-content) {\r\n\t\tmargin-top: -15px;\r\n\t}\r\n\t\r\n\t.cost {\r\n\t\tmargin: 0;\r\n\t\tfont-size: 30px;\r\n\t}\r\n\t\r\n\t.table table tr {\r\n\t\tgrid-template-columns: 2fr 1fr 1fr 1fr;\r\n\t\tgrid-template-areas: \"name name orders cost avg\";\r\n\t}\r\n\t\r\n\t.table table thead tr th {\r\n\t\tmax-height: 31px !important;\r\n\t}\r\n\t\r\n\t.table :global(.p-datatable-thead th) {\r\n\t\tpadding: 10px 0;\r\n\t}\r\n\t\r\n\t.table :global(.p-datatable-thead th:first-child > div) {\r\n\t\tmargin-left: 30px;\r\n\t}\r\n}\r\n\r\n@media screen and (max-width: 768px) {\r\n\t.table table thead tr th > div > span {\r\n\t\tfont-size: 10px;\r\n\t\tfont-weight: 700;\r\n\t}\r\n\t\r\n\t.table table tbody tr td > div {\r\n\t\tfont-size: 10px;\r\n\t\tfont-weight: 400;\r\n\t}\r\n}\r\n\r\n@media screen and (max-width: 425px) {\r\n\t.table table tr {\r\n\t\tgrid-template-columns: 2fr 1fr 1fr 2fr;\r\n\t\tgrid-template-areas: \"name name orders cost avg avg\";\r\n\t}\r\n}"],"sourceRoot":""}]);
// Exports
export var chartsBlock = `h7mpwEJdV4MbabsO`;
export var cardWrapper = `VzoN2HOB1MK6QYt_`;
export var chartCard = `gCypkPVVZYnFa_hh`;
export var card = `a3BewcesEvIca0PY`;
export var totalOrdersCardContent = `ahyuFXrae04ItvA7`;
export var doughnut = `Sb2oxBfh71cCntoA`;
export var customLegend = `oWO1O9Y_pDc9Wz2P`;
export var label = `GbUK_ulCL4_iYyvS`;
export var labelTitle = `Kd1Cu29uAAN9VNu1`;
export var labelValue = `WUMelefkZNQJJ6Fe`;
export var labelDot = `KjsVkF88_k5Gkx4_`;
export var cost = `Ll3rZz7id5wZoNB_`;
export var costsBlock = `W79xGQzqTuc6ECc0`;
export var downloadBtn = `wf_ILWo04gS4M8u8`;
export var table = `Ijgt54fh69YSQyTe`;
export var cellName = `Ut0J3vuXbFkaUtZi`;
export var cellOrders = `BBzn2su5Wu0eX7ws`;
export var cellCost = `rAS5iAeu7wTid_Iu`;
export var cellAvg = `eeXFbYAcxiwJ0B_g`;
export default ___CSS_LOADER_EXPORT___;
